import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent  {

  @Input() picto: string;
  @Input() buttonTitle: string;
  @Input() buttonSubtitle:string;
  
  constructor() { }

}
